import { render } from "./AgentePresenciaJunta.vue?vue&type=template&id=1c3c80d1&scoped=true"
import script from "./AgentePresenciaJunta.vue?vue&type=script&lang=ts"
export * from "./AgentePresenciaJunta.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-1c3c80d1"

export default script